export default function openNewTab (url: string)  {
    const res = window.open(url, "_blank");
    res && res.focus();
  };